export default __webpack_public_path__ + "static/media/sampling.18637a3f.jpg";